import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { getSucjectMethodsConfig } from '../../../functions/getSucjectMethodsConfig';
import { requirementsPersonalizationConfig } from '../Block32';
import { individualSupportConfig } from '../Block33';
import { FormBlock3DataTypes } from './DocumentPreviewSubjectData';
import { PreviewNestedData } from './PreviewNestedData';

type DocumentPreviewBlock3Props = {
  data: FormBlock3DataTypes;
  selectedSubject: string;
};

export const DocumentPreviewBlock3 = ({
  data,
  selectedSubject,
}: DocumentPreviewBlock3Props) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      methods: {
        key: 'methods',
        methods: {},
      },
      requirementsPersonalization: {
        key: 'requirementsPersonalization',
        requirementsPersonalization: {},
      },
      individualSupport: {
        key: 'individualSupport',
        individualSupport: {},
      },
    };
    if (data && selectedSubject) {
      if (data.methods) {
        changedTableData.methods.methods = (
          <PreviewNestedData
            fieldsData={data.methods}
            fieldsConfig={getSucjectMethodsConfig(selectedSubject)}
          />
        );
      }
      if (data.requirementsPersonalization) {
        changedTableData.requirementsPersonalization.requirementsPersonalization =
          (
            <PreviewNestedData
              fieldsData={data.requirementsPersonalization}
              fieldsConfig={requirementsPersonalizationConfig}
            />
          );
      }
      if (data.individualSupport) {
        changedTableData.individualSupport.individualSupport = (
          <PreviewNestedData
            fieldsData={data.individualSupport}
            fieldsConfig={individualSupportConfig}
          />
        );
      }
    }
    return changedTableData;
  }, [data, selectedSubject]);

  return (
    <div>
      <Typography.Title level={5}>Baziniai pritaikymai</Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'methods',
            title: 'Pamokoje naudojami ugdymo būdai ir metodai',
            dataIndex: 'methods',
          },
        ]}
        dataSource={[tableData.methods ? tableData.methods : {}]}
        size="small"
      />
      <Table
        pagination={false}
        columns={[
          {
            key: 'requirementsPersonalization',
            title: 'Reikalavimų personalizavimas',
            dataIndex: 'requirementsPersonalization',
          },
        ]}
        dataSource={[
          tableData.requirementsPersonalization
            ? tableData.requirementsPersonalization
            : {},
        ]}
        size="small"
      />
      <Table
        pagination={false}
        columns={[
          {
            key: 'individualSupport',
            title: 'Teikiama individuali pagalba',
            dataIndex: 'individualSupport',
          },
        ]}
        dataSource={[
          tableData.individualSupport ? tableData.individualSupport : {},
        ]}
        size="small"
      />
    </div>
  );
};
